<template>
  <modal :fullscreen="true" :show="show" @close="close">
    <v-flex slot="title">{{ !!id ? 'Edytuj stronę' : 'Dodaj stronę' }}</v-flex>

    <div>
      <v-layout>
        <v-flex pr-2 xs6>
          <w-schema :model="$schema.name">
            <v-text-field label="Tytuł strony*" />
          </w-schema>
        </v-flex>
        <v-flex pr-2 xs6>
          <w-schema :model="$schema.slug">
            <v-text-field label="Slug strony" />
          </w-schema>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex pr-2 xs6>
          <w-schema :model="$schema.priority">
            <v-text-field label="Priorytet*" type="number" />
          </w-schema>
        </v-flex>

        <v-flex pr-2 xs6>
          <w-select
            item-text="text"
            item-value="value"
            label="Status strony*"
            :items="stateItems"
            :model="$schema.state"
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex xs12>
          <w-select
            item-text="text"
            item-value="value"
            label="Typ strony*"
            :items="typeItems"
            :model="$schema.type"
            @change="clearData"
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex xs12>
          <w-schema :model="$schema.slots">
            <v-select
              multiple
              item-text="text"
              label="Miejsca wyświetlania strony"
              item-value="value"
              :items="slotItems"
            />
          </w-schema>
        </v-flex>
      </v-layout>

      <div v-if="$schema.type.$model === PageType.URL">
        <v-flex class="mb-4" xs12>
          <w-schema :model="$schema.data">
            <v-text-field label="Adres URL*" />
          </w-schema>
        </v-flex>
      </div>

      <div v-else-if="$schema.type.$model === PageType.MailTemplate">
        <w-select
          item-text="name"
          item-value="idString"
          label="Szablon wiadomości*"
          :items="list"
          :model="$schema.data"
        />
      </div>

      <div v-if="showContent">
        <v-flex class="mb-4" xs12>
          <html-editor :schema="$schema.content" :code-editor="true" />
        </v-flex>

        <v-flex v-if="canHaveMedia" class="mb-4">
          <v-layout row wrap>
            <v-flex xs12 md6>
              <single-image :schema="$schema.mainImage" />
            </v-flex>

            <v-flex xs12 md6>
              <images-list :schema="$schema.images" />
            </v-flex>
          </v-layout>
        </v-flex>
      </div>

      <div v-if="canHaveMedia">
        <v-label>Załączniki do pobrania na stronie</v-label>

        <media :schema="$schema.media" />
      </div>

      <span class="caption grey--text">*oznaczone pola są wymagane</span>
    </div>

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>
<script>
import {
  PageSlots,
  PageSlotsTranslation,
  PageType,
  PageTypeTranslation,
  State,
  StateString,
  StateTranslation
} from '@witkac/kartamiejska-shared';
import { WSchema, WSelect } from '@witkac/vuetify-components';
import { mapState } from 'vuex';

import HtmlEditor from '@/components/forms/HtmlEditor';
import ImagesList from '@/components/forms/ImagesList';
import Media from '@/components/forms/Media';
import SingleImage from '@/components/forms/SingleImage';
import modal from '@/components/material/Modal';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/page.schema';

const emptyData = () => ({
  mainImage: null,
  images: '',
  name: '',
  slug: '',
  priority: null,
  state: '',
  type: '',
  content: '',
  data: '',
  slots: []
});
// @vuese
// Modal do dodawania/edycji stron
// @group Pages
export default {
  components: { modal, WSchema, WSelect, WSchema, HtmlEditor, ImagesList, SingleImage, Media },
  mixins: [manageMixin('pages', {}, emptyData)],
  schema,
  computed: {
    ...mapState({
      list: state => {
        const list = state.mailTemplates.list.map(item => {
          item.idString = item.id.toString();
          return item;
        });
        return list;
      }
    }),
    showContent() {
      return this.pageTypesWithContent.includes(this.$schema.type.$model);
    },
    canHaveMedia() {
      return (
        this.show && (this.$schema.type.$model === PageType.HTML || this.$schema.type.$model === PageType.MailTemplate)
      );
    }
  },
  data() {
    return {
      stateItems: [
        { text: StateTranslation[State.ACTIVE], value: StateString.ACTIVE },
        { text: StateTranslation[State.INACTIVE], value: StateString.NOT_CONFIRMED }
      ],
      typeItems: [
        { text: PageTypeTranslation[PageType.HTML], value: PageType.HTML },
        { text: PageTypeTranslation[PageType.MailTemplate], value: PageType.MailTemplate },
        { text: PageTypeTranslation[PageType.URL], value: PageType.URL },
        { text: PageTypeTranslation[PageType.Partner], value: PageType.Partner },
        { text: PageTypeTranslation[PageType.Places], value: PageType.Places },
        { text: PageTypeTranslation[PageType.Events], value: PageType.Events }
      ],
      slotItems: [
        { text: PageSlotsTranslation[PageSlots.HEADER], value: PageSlots.HEADER },
        { text: PageSlotsTranslation[PageSlots.FOOTER], value: PageSlots.FOOTER }
      ],

      PageType,
      pageTypesWithContent: [PageType.HTML, PageType.MailTemplate]
    };
  },
  methods: {
    // @vuese
    // Pobiera liste szablonów
    getTemplates() {
      this.$store.dispatch(`mailTemplates/list`, { count: 0 }).catch(err =>
        this.$store.dispatch('notifyError', {
          title: 'Wystąpił błąd podczas pobierania listy szablonów'
        })
      );
    },
    // @vuese
    // Czyści pole data
    clearData() {
      this.$schema.data.$model = '';
    }
  },

  mounted() {
    this.getTemplates();
  }
};
</script>
